import { Avatar, Dropdown, Navbar, Text } from '@nextui-org/react'
import { Badge } from 'antd'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import j2bdWhiteLogo from '../../../../assets/images/j2bd-white.svg'
import holloLogo from '../../../../assets/images/loghollo.png'
import AuthTalent from '../../../../services/AuthTalent'
import { checkFeatureFlag } from '../../../../utils/featureFlag'

function CustomNavbar({ setIsProfileFormOpen }) {
  const talent = useSelector((state) => state.talent)
  const { firstname, lastname, email } = talent

  const history = useHistory()
  const logout = useCallback(() => {
    AuthTalent.logout()
    history.push('/app/login')
  }, [history])

  const { company } = useSelector((state) => state.talent)
  const { likes } = useSelector((state) => state.talent)
  const { matchingOffers } = useSelector((state) => state.talent)

  const location = useLocation()

  const { t } = useTranslation(['common'], {
    useSuspense: false,
  })

  return (
    <Navbar isCompact isBordered variant="sticky">
      <Navbar.Brand>
        <img
          src={checkFeatureFlag ? j2bdWhiteLogo : holloLogo}
          height={30}
          alt=""
          className="logo"
        />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {company?.logo && <img src={company.logo} alt="Icon" height={40} />}
        </div>
      </Navbar.Brand>
      <Navbar.Content hideIn="xs" variant="underline">
        <Navbar.Link isActive={location.pathname === '/app/jobs'}>
          <Link
            to="/app/jobs"
            style={{
              paddingTop: '19px',
              paddingBottom: '19px',
              paddingRight: '5px',
            }}
          >
            {t('common:stepType.offersSuggestions')}
          </Link>
        </Navbar.Link>
        {matchingOffers.length + likes.pending.length > 0 && (
          <Badge
            count={matchingOffers.length + likes.pending.length}
            style={{
              right: 20,
              backgroundColor:
                location.pathname === '/app/jobs' ? '' : '#eb5b56',
            }}
          />
        )}

        <Navbar.Link isActive={location.pathname === '/app/applications'}>
          <Link
            to="/app/applications"
            style={{
              paddingTop: '19px',
              paddingBottom: '19px',
            }}
          >
            {t('common:stepType.myJob')}
          </Link>
        </Navbar.Link>
        <Navbar.Link isActive={location.pathname === '/app/profile'}>
          {' '}
          <Link
            to="/app/profile"
            style={{
              paddingTop: '19px',
              paddingBottom: '19px',
            }}
          >
            {t('common:myProfile')}
          </Link>
        </Navbar.Link>
      </Navbar.Content>

      <Navbar.Content>
        <p style={{ color: 'white' }}>
          {firstname && lastname
            ? `${
                firstname.charAt(0).toUpperCase() + firstname.slice(1)
              } ${lastname.charAt(0).toUpperCase()}${lastname.slice(1)}`
            : null}
        </p>
        <Dropdown placement="bottom-left">
          <Dropdown.Trigger>
            <Avatar
              bordered
              size="md"
              as="button"
              name="Tony Reichert"
              text={
                firstname && lastname
                  ? firstname[0].toUpperCase() + lastname[0].toUpperCase()
                  : null
              }
            />
          </Dropdown.Trigger>
          <Dropdown.Menu color="secondary" aria-label="Avatar Actions">
            <Dropdown.Item
              key="profile"
              css={{
                height: '$18',
                '&:hover': {
                  background: 'none',
                  color: 'none',
                  cursor: 'default',
                },
                '&:active': {
                  background: 'none',
                },
                '&:focus': {
                  background: 'none',
                },
              }}
            >
              <Text
                b
                color="inherit"
                css={{
                  d: 'flex',
                }}
              >
                Connecté en tant que
              </Text>
              <Text
                b
                color="inherit"
                css={{
                  d: 'flex',
                  textGradient: '45deg, $yellow600 -20%, $red600 100%',
                }}
              >
                {email}
              </Text>
            </Dropdown.Item>

            <Dropdown.Item key="settings" withDivider>
              <p
                onClick={setIsProfileFormOpen}
                role="button"
                onKeyDown={() => null}
                style={{
                  height: '100% !important',
                  marginTop: '6%',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                  borderRadius: '6px',
                }}
              >
                Réglages
              </p>
            </Dropdown.Item>

            <Dropdown.Item key="logout" color="error" withDivider>
              <p
                onClick={logout}
                role="button"
                onKeyDown={() => null}
                style={{
                  height: '100% !important',
                  marginTop: '6%',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                  borderRadius: '6px',
                }}
              >
                Déconnexion
              </p>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Navbar.Content>
    </Navbar>
  )
}

CustomNavbar.propTypes = {
  setIsProfileFormOpen: PropTypes.func.isRequired,
}

CustomNavbar.defaultProps = {}

export default CustomNavbar
